import { isEqual, isNil, isObject, isString } from 'lodash';
import { API } from '@shared/types/api';
import { EditableField, Field } from './Field';

export interface Subform {
  workflowTemplateId: string;
  data: Record<string, any>;
}

export class SubformField implements EditableField {
  readonly subform: Subform;
  readonly workflowTemplate?: API.WorkflowTemplateFragment | undefined;
  readonly fieldType = 'SubformField';

  constructor(
    subform: Subform,
    workflowTemplateRefs?:
      | NonNullable<
          NonNullable<API.ListWorkflowEntitiesQuery['list']['refs']>['workflowTemplateRefs']
        >[number][]
      | null,
  ) {
    this.subform = subform;
    this.workflowTemplate = workflowTemplateRefs?.find(
      w => w.id === subform?.workflowTemplateId,
    ) as API.WorkflowTemplateFragment | undefined;
  }

  validate(): string | null {
    return null;
  }

  isEqual(field: Field): boolean {
    return field instanceof SubformField && isEqual(this.subform, field.subform);
  }

  toFieldJson() {
    return this.subform;
  }

  get isEmpty() {
    return isNil(this.subform?.workflowTemplateId);
  }

  static fromFieldJson(
    jsonBlob: any,
    workflowTemplateRefs?:
      | NonNullable<
          NonNullable<API.ListWorkflowEntitiesQuery['list']['refs']>['workflowTemplateRefs']
        >[number][]
      | null,
  ): SubformField | null {
    if (isSubform(jsonBlob)) {
      return new SubformField(jsonBlob, workflowTemplateRefs);
    } else {
      return null;
    }
  }
}

function isSubform(jsonBlob: any): jsonBlob is Subform {
  return !isNil(jsonBlob) && isString(jsonBlob.workflowTemplateId) && isObject(jsonBlob.data);
}
